define.alias("ember-tooltips/components/ember-tooltip", "preview-grid/components/ember-tooltip");